<template>
  <v-overlay :absolute="true" :value="isActive" class="copy-success">
    <div class="copy-overlay-indicator">
      <v-icon size="50" color="white">fas fa-check</v-icon>
      <div><span class="application-heading">Copied</span></div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "CopyToClipboard",
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    /**
     * Copies the given text and shows the success message
     * @param {string} text
     */
    copy(text) {
      if (text) {
        this.isActive = true;
        this.copyToClipboard(text);
        setTimeout(() => {
          this.isActive = false;
        }, 500);
      }
    },
  },
};
</script>

<style scoped>
.v-overlay {
  background-color: rgba(0, 0, 0, 0) !important;
}
.v-overlay--active.v-overlay {
  background-color: rgba(0, 0, 0, 0.307) !important;
}
.copy-overlay-indicator {
  width: 120px;
  height: 120px;
  background-color: var(--primary-color);
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  font-size: large;
}
</style>
